import {
  SOLIDITY_SCAN_PLATFORMS_MAPPING,
  platforms
} from "../../pages/business/SolidityScan";

const SolidityScanForm = ({
  platform,
  contactAddress,
  chain,
  setContactAddress,
  setChain,
  setPlatform,
  scanReport
}: {
  platform: string;
  contactAddress: string;
  chain: string;
  setContactAddress: (value: string) => void;
  scanReport: () => any;
  setPlatform: (value: string) => void;
  setChain: (value: string) => void;
}) => {
  return (
    <>
      <div className="form-group">
        <label>Contract Address</label>
        <input
          type="text"
          placeholder="Contract Address"
          className="form-control"
          value={contactAddress}
          onChange={e => setContactAddress(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>Contract Platform</label>
        <select
          className="form-control"
          value={platform}
          onChange={e => setPlatform(e.target.value)}
        >
          {platforms.map((platform, index) => (
            <option key={index} value={platform}>
              {SOLIDITY_SCAN_PLATFORMS_MAPPING[index].label}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Contract Chain</label>
        <select
          className="form-control"
          value={chain}
          onChange={e => setChain(e.target.value)}
        >
          {SOLIDITY_SCAN_PLATFORMS_MAPPING[
            platforms.indexOf(platform) ?? 0
          ].contract_chains.map((chain, index) => (
            <option key={index} value={chain.value}>
              {chain.label}
            </option>
          ))}
        </select>

        <button className="btn btn-primary" onClick={scanReport}>
          Scan
        </button>
      </div>
    </>
  );
};

export default SolidityScanForm;
